module.exports = __webpack_public_path__ + "870bbfcabc6a6a8bf601dbbc48f03311.svg";